// src/components/ProtectedRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from 'react-bootstrap';

const LOADING_TIMEOUT = 20000; // 20 วินาที — ถ้า loading นานกว่านี้ ถือว่ามีปัญหา

const ProtectedRoute = ({ children, allowedRoles, permissionKey, permissionAction = 'view' }) => {
  const { isAuthenticated, isLoading, user, hasPermission } = useAuth();
  const [isTimedOut, setIsTimedOut] = useState(false);

  // ⏱️ Loading Timeout — ป้องกัน spinner ค้างตลอดไป
  useEffect(() => {
    if (!isLoading) {
      setIsTimedOut(false);
      return;
    }

    const timer = setTimeout(() => {
      console.error('⏱️ ProtectedRoute: Loading timeout — redirect to login');
      setIsTimedOut(true);
    }, LOADING_TIMEOUT);

    return () => clearTimeout(timer);
  }, [isLoading]);

  // ถ้า timeout → redirect ไป login ทันที
  if (isTimedOut) {
    // Clear only auth tokens; do not wipe user drafts/preferences in localStorage.
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If roles are specified, check if user has permission
  const isAdmin = user?.role === 'admin';
  const hasRole = allowedRoles ? allowedRoles.includes(user?.role) : false;
  const hasPerm = permissionKey ? hasPermission(permissionKey, permissionAction) : false;
  if ((permissionKey || allowedRoles) && !isAdmin && !hasRole && !hasPerm) {
    return <Navigate to="/profile" replace />;
  }

  return children;
};

export default ProtectedRoute;
